export default __webpack_public_path__ + "static/media/spectrophotometer-info-4.65d03e1e.svg";